<template>
  <template v-if="isLoading">
    <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
  </template>
  <template v-else>
    <div class="contents syain">
      <h2>社員マスタ　一覧</h2>
      <div class="search">
        <h3>検索項目</h3>
        <div class="item-container">
          <div class="col-item" v-if="authStore.hasPermission(PermissionConst.SYAIN_MASTER_SEARCH_ALL)">
            <b>所属</b>
            <select-box :options="options.mst_syozoku" v-model="searchForm.syozokuId" :hasBlank="true"></select-box>
          </div>
          <div class="col-item">
            <b>フリガナ</b>
            <input-text type="text" v-model="searchForm.kana"></input-text>
          </div>
          <div class="col-item">
            <b>資格</b>
            <input-text type="text" v-model="searchForm.shikaku"></input-text>
          </div>
          <div class="col-item">
            <b>権限ロール</b>
            <select-box :options="options.mst_role" v-model="searchForm.mst_role_id" :hasBlank="true"></select-box>
          </div>
        </div>
        <div class="btn-container">
          <button type="button" class="btn clear" @click="clear">クリア</button>
          <button type="button" class="btn primary" @click="search()"><i
              class="fa-solid fa-magnifying-glass"></i>検索</button>
        </div>
      </div>

      <component :is="List" :dataList="dataList" :isLoading="isListLoading" :isError="isError"
         />

    </div>
  </template>
  <!--contents-->
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from "vue"
import { useList } from "@/composable/syain/list/list"
import { useInit } from "@/composable/syain/list/init"
import { useForm } from "@/composable/form/form"
import { useSyainStore } from '@/store/syain'
import List from "@/components/syain/List.vue"
import { useAuthStore } from "@/store/auth"
import { PermissionConst } from '@/const/Permission'

export default defineComponent({
  setup() {
    // 初期化
    const { searchForm, isLoading, options } = useInit();
    const { getList, isListLoading, isError, dataList } = useList();
    const syainStore = useSyainStore();
    const authStore = useAuthStore();

    // 検索ボタンクリック
    const search = () => {
      syainStore.setItem(searchForm.value);
      getList(searchForm.value);
    }

    // クリアボタンクリック
    const clear = () => {
      searchForm.value = {
        kana: null,
        syozokuId: null,
        shikaku: null,
        mst_role_id: null,
      };
    }

    // 初期取得
    onMounted(() => {
      searchForm.value = syainStore.item;
      // 社員情報一覧取得
      getList(searchForm.value);
    });

    // エラー取得
    const { getError } = useForm();

    return {
      getError,
      isLoading,
      isListLoading,
      options,
      searchForm,
      search,
      clear,
      dataList,
      List,
      isError,
      authStore,
      PermissionConst,
      // dispDataList,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-list.scss';
</style>